var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecrease({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(-885.393 -681.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_202",
    "data-name": "Ellipse 202",
    transform: "translate(885.393 681.859)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 13.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_446",
    "data-name": "Line 446",
    x1: 13.553,
    transform: "translate(893.326 696.359)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrease);
export default __webpack_public_path__ + "static/media/decrease.d0cdf8928b035f1aa998086c4873b235.svg";
export { ForwardRef as ReactComponent };